export default __webpack_public_path__ + "static/media/angelie1.691ee112.jpg";